import { useContext } from "react";
import { Context } from "../provider";

export default function useRootElement() {
	const root = useContext(Context);
	if (!root) {
		throw new Error("Root not found");
	}
	return root.shadowRoot || root;
}
